import { useContext, useState, useEffect } from "react";
import { TotalEntradaUtils } from "../../utils/TotalEntradaUtils";
import { ValidarEntrada } from "../../utils/ValidarEntrada";
import { ValidarMembresia } from "../../utils/ValidarMembresia";
import { ValidarStock } from "../../utils/ValidarStock";
import SiteMapViewer from "./SiteMapViewer";

const OfComprarEntradas = ({
  setStep,
  step,
  entradas,
  onClick,
  comission,
  form,
  evento,
  fechas,
  label,
  image,
  me,
  setmembresia,
  asientosSeleccionados,
  setAsientosSeleccionados,
}) => {
  const [siteMap, setSiteMap] = useState(null);
  const [entradaConSector, setEntradaConSector] = useState(null);

  // Cargar site_maps cuando se carga el evento
  useEffect(() => {
    console.log("=== EVENTO RECIBIDO EN COMPRAR ENTRADAS (MOBILE) ===");
    console.log("Evento completo:", evento);
    console.log("Reportes del evento:", evento?.reportes);

    if (evento && evento.site_maps) {
      console.log("site_maps encontrado:", evento.site_maps);

      const siteMapData = evento.site_maps;
      console.log("Datos de site_map:", siteMapData);

      // Parsear site_map si viene como string
      let parsedSiteMap = siteMapData.site_map;
      console.log("Tipo de site_map:", typeof parsedSiteMap);

      if (typeof parsedSiteMap === 'string') {
        try {
          parsedSiteMap = JSON.parse(parsedSiteMap);
          setSiteMap(parsedSiteMap);
          console.log("Site map parseado y guardado:", parsedSiteMap);
        } catch (e) {
          console.error("Error al parsear site_map:", e);
        }
      } else {
        setSiteMap(parsedSiteMap);
        console.log("Site map guardado (ya es objeto):", parsedSiteMap);
      }
    } else {
      console.log("No se encontró site_maps en el evento");
    }
  }, [evento]);

  // Detectar si hay entradas con sector
  useEffect(() => {
    console.log("Verificando entradas con sector:", entradas);

    // Verificar diferentes formatos posibles del campo sector
    const hayEntradasConSector = entradas.some(entrada => {
      console.log("Verificando entrada:", entrada);
      console.log("Campo sector:", entrada.sector);

      // Puede venir como string directo o como objeto/array
      if (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") {
        return true;
      }
      // Podría venir como objeto con propiedad [0]
      if (entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "") {
        return true;
      }
      return false;
    });

    console.log("¿Existen entradas con sector?:", hayEntradasConSector);
    setEntradaConSector(hayEntradasConSector);
  }, [entradas]);

  // Manejar selección de asiento
  const handleAsientoSelect = (asiento) => {
    setAsientosSeleccionados(prev => {
      const index = prev.findIndex(a => a.id === asiento.id);
      if (index > -1) {
        // Deseleccionar
        return prev.filter(a => a.id !== asiento.id);
      } else {
        // Seleccionar
        return [...prev, asiento];
      }
    });
  };

  // Sincronizar cantidad de entradas con asientos seleccionados
  useEffect(() => {
    console.log("Sincronizando asientos seleccionados:", asientosSeleccionados);

    // Iterar sobre TODAS las entradas con sector y actualizar sus cantidades
    entradas.forEach((entrada, index) => {
      const tieneSector = (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") ||
                         (entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "");

      if (tieneSector) {
        // Contar asientos seleccionados de este sector específico
        const cantidadAsientos = asientosSeleccionados.filter(a => a.sector_id == entrada.id).length;

        console.log(`Entrada ${entrada.id} (${entrada.nombre}): ${cantidadAsientos} asientos seleccionados`);

        // Actualizar solo si cambió la cantidad
        if (entrada.quantity !== cantidadAsientos) {
          const event = { target: { name: 'update-quantity-from-sitemap' } };
          const value = {
            index: index,
            cantidad: cantidadAsientos,
            precio: entrada.precio
          };

          console.log(`Actualizando entrada ${entrada.id} a cantidad: ${cantidadAsientos}`);
          onClick(event, value);
        }
      }
    });
  }, [asientosSeleccionados]);

  return (
    <div
      className="offcanvas offcanvas-top min-vh-100"
      tabindex="-1"
      id="offcanvasTop-comprar-entradas"
      aria-labelledby="offcanvasTopLabel"
    >
      <div className="offcanvas-header py-2">
        <h5
          className="offcanvas-title Grifter"
          id="offcanvasTopLabel-comprar-entradas"
          style={{ fontSize: "12px" }}
        ></h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="row">
          <div className="col-12 mb-3">
            {(() => {
              console.log("Estado de renderizado - siteMap:", siteMap);
              console.log("Estado de renderizado - entradaConSector:", entradaConSector);
              console.log("¿Debería mostrar mapa?", siteMap && entradaConSector);
              return null;
            })()}
            {siteMap && entradaConSector ? (
              <div className="p-2">
                <h6 className="text-success">MAPA DE ASIENTOS</h6>
                <SiteMapViewer
                  fechaSeleccionada={`${form.fecha} HORA: ${form.hora}`}
                  siteMap={siteMap}
                  onAsientoSelect={handleAsientoSelect}
                  asientosSeleccionados={asientosSeleccionados.map(a => a.id)}
                  entradas={entradas}
                  reportes={evento.reportes}
                />
                {asientosSeleccionados.length > 0 && (
                  <div className="mt-2 p-2 bg-light rounded">
                    <small className="fw-bold">Asientos seleccionados:</small>
                    <div className="d-flex flex-wrap gap-1 mt-1">
                      {asientosSeleccionados.map(asiento => (
                        <span key={asiento.id} className="badge bg-success">
                          Fila {asiento.fila} - Asiento {asiento.numero}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </div>
          <div className="col-md-5 d-none">
            <div className="border h-100 overflow-hidden">
              <img
                src={image}
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
                alt=""
              />
            </div>
          </div>
          <div className="col-md-7">
            <div>
              <nav>
                <div
                  className="nav nav-tabs d-flex justify-content-center align-items-center border-0 py-3"
                  id="nav-tab-ofcanva"
                  role="tablist"
                >
                  <button
                    className={
                      step == 0
                        ? "bg-transparent fw-bold text-custom-naranja border-0 d-flex items-align-center "
                        : "bg-transparent fw-bold text-dark border-0 d-flex items-align-center "
                    }
                    onClick={() => setStep(0)}
                    id="nav-cantidad-tab-ofcanva"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-cantidad-ofcanva"
                    type="button"
                    role="tab"
                    aria-controls="nav-cantidad-ofcanva"
                    aria-selected="false"
                  >
                    <i
                      className={
                        step == 0
                          ? "bi bi-2-circle-fill text-custom-naranja fw-bold titulo-size me-2"
                          : "bi bi-2-circle-fill text-dark fw-bold titulo-size me-2"
                      }
                    ></i>
                    <span className="titulo-size Grifter">Elegir entrada</span>
                  </button>
                  <div
                    className="d-none d-md-block"
                    style={{
                      borderBottom: "1px solid black",
                      width: "60px",
                      height: "1px",
                    }}
                  ></div>
                  <button
                    className={
                      step == 1
                        ? "bg-transparent fw-bold text-custom-naranja border-0 d-flex items-align-center me-3"
                        : "bg-transparent fw-bold text-dark border-0 d-flex items-align-center me-3"
                    }
                    onClick={() => setStep(1)}
                    id="nav-pagar-tab-ofcanva"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-pagar-ofcanva"
                    type="button"
                    role="tab"
                    aria-controls="nav-pagar-ofcanva"
                    aria-selected="false"
                  >
                    <i
                      className={
                        step == 1
                          ? "bi bi-3-circle-fill text-custom-naranja fw-bold titulo-size me-2"
                          : "bi bi-3-circle-fill text-dark fw-bold titulo-size me-2"
                      }
                    ></i>
                    <span className="titulo-size Grifter">Pagar</span>
                  </button>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent-ofcanva">
                <div
                  className="tab-pane fade py-5 show active"
                  id="nav-cantidad-ofcanva"
                  role="tabpanel"
                  aria-labelledby="nav-cantidad-tab-ofcanva"
                  tabindex="0"
                >
                  {entradas.map((entrada, index) => {
                    // Verificar sector en diferentes formatos
                    const tieneSector = (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") ||
                      (entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "");

                    const nombreSector = typeof entrada.sector === 'string' ? entrada.sector : (entrada.sector && entrada.sector[0] ? entrada.sector[0] : "");

                    // Lógica de ocultamiento:
                    // Si existen entradas con sector (entradaConSector = true) Y esta entrada NO tiene sector (tieneSector = false)
                    // entonces ocultarla
                    const debeOcultarse = entradaConSector && !tieneSector;

                    return (
                      <div
                        key={index}
                        className={`${ValidarEntrada(entrada) ? "" : "d-none"} ${debeOcultarse ? "d-none" : ""}`}
                      >
                        <div
                          className="text-center  d-md-flex d-block justify-content-between"
                          style={{
                            opacity: entrada.quantity ? 1 : 0.5,
                          }}
                        >
                          <div className="fw-bold fs-6 text-start text-dark d-block">
                            <div>{entrada.nombre}
                                  {
                                    entrada.multiplicador
                                    ? ` x${entrada.multiplicador}`
                                    : ''
                                  }
                            </div>
                            {tieneSector && (
                              <small className="text-muted d-block">
                                Sector: {nombreSector}
                              </small>
                            )}
                          </div>
                          <span className="fw-bold fs-5 text-dark">
                            $
                            {entrada.pricexquantity
                              ? parseFloat(
                                  entrada.pricexquantity
                                ).toLocaleString("es-AR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : parseFloat(entrada.precio).toLocaleString(
                                  "es-AR",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                          </span>
                          <div>
                            {tieneSector ? (
                              <div className="text-center">
                                <div className="badge bg-info text-dark mb-2">
                                  {entrada.quantity ?? 0} asiento{(entrada.quantity ?? 0) !== 1 ? 's' : ''} seleccionado{(entrada.quantity ?? 0) !== 1 ? 's' : ''}
                                </div>
                                <small className="d-block text-muted">
                                  Selecciona en el mapa
                                </small>
                              </div>
                            ) : (
                              <div className=" d-flex justify-content-center">
                                <button
                                  className="btn py-2 px-4 fw-bold fs-6 border border-dark"
                                  style={{
                                    borderRadius: "20px 0px 0px 20px",
                                  }}
                                  name="remove"
                                  onClick={(event) =>
                                    onClick(event, {
                                      ...entrada,
                                      index: index,
                                    })
                                  }
                                >
                                  -
                                </button>
                                <input
                                  className="form-controll py-1 text-center fs-6 GothamBold"
                                  type="number"
                                  value={entrada.quantity ?? 0}
                                  style={{ width: "100px" }}
                                  readOnly
                                />
                                <button
                                  className="border-dark btn py-1 px-4 fw-bold fs-6 border"
                                  style={{
                                    borderRadius: "0px 20px 20px 0px",
                                  }}
                                  name="add"
                                  onClick={(event) => {
                                    if (entrada.remain !== 0) {
                                      onClick(event, {
                                        ...entrada,
                                        index: index,
                                      });
                                    }
                                  }}
                                >
                                  +
                                </button>
                              </div>
                            )}

                            <span
                              className={`${
                                ValidarStock(entrada, form, evento.reportes)
                                  ? "d-none"
                                  : ""
                              }`}
                              style={{ fontSize: "10px" }}
                            >
                              <span className={`ms-1`}>Entradas agotadas</span>
                            </span>

                            <span
                              className={`${
                                ValidarStock(entrada, form, evento.reportes)
                                  ? ""
                                  : "d-none"
                              }`}
                              style={{ fontSize: "10px" }}
                            >
                              {"+Serv ARS " +
                                parseFloat(entrada.serv ?? 0).toLocaleString(
                                  "es-AR",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                ) ?? 0}
                              <span
                                className={`ms-1  ${
                                  entrada.remain <= 20 ? "" : "d-none"
                                }`}
                              >
                                Quedan {entrada.remain ?? 0} entradas!
                              </span>
                            </span>
                          </div>
                        </div>

                        <hr></hr>
                      </div>
                    );
                  })}

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <span className="d-block fw-bold">{evento?.nombre}</span>
                      <span className="d-block">{evento?.nombre_sitio}</span>
                      <span className="d-block">{`${form.fecha} Hora: ${form.hora}`}</span>
                    </div>
                    <div className="col-md-6">
                      <div className="w-100 d-flex justify-content-between">
                        <div className="fs-6 fw-bold">SubTotal</div>
                        <div className="fs-6 fw-bold">
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission)
                                .subTotal
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </div>
                      </div>
                      <div className="w-100 d-flex justify-content-between">
                        <div className="fs-6 fw-bold">+Serv ({comission}%)</div>
                        <div className="fs-6 fw-bold">
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission).serv
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </div>
                      </div>
                      <div className="w-100 d-flex justify-content-between">
                        <div className="fs-6 fw-bold">Total</div>
                        <div className="fs-6 fw-bold">
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission)
                                .total
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="nav-pagar-ofcanva"
                  role="tabpanel"
                  aria-labelledby="nav-pagar-tab-ofcanva"
                  tabindex="1"
                >
                  <ul class="list-group">
                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 mb-1 border-start-0 border-end-0">
                      <span className="d-block fw-bold">{evento?.nombre}</span>
                      <span className="d-block">{evento?.nombre_sitio}</span>
                      <span className="d-block">{`${form.fecha} Hora: ${form.hora}`}</span>
                    </li>

                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                      <span className="GothamBold d-block">Entradas</span>
                      {evento?.entradas.map((entrada, index) => {
                        if (entrada.quantity > 0) {
                          return (
                            <div
                              className="d-flex justify-content-between"
                              key={index}
                            >
                              <span className="GothamBold fs-6">
                                {`${entrada.nombre} x${entrada.quantity}`}
                              </span>
                              <span className="GothamBold fs-6">{`ARS ${parseFloat(
                                entrada.pricexquantity
                              ).toLocaleString("es-AR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}</span>
                            </div>
                          );
                        }
                      })}
                    </li>

                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                      <div className="d-flex justify-content-between">
                        <span className="GothamBold fs-6">SubTotal</span>
                        <span className="GothamBold fs-6">
                          {" "}
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission)
                                .subTotal
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </span>
                      </div>
                    </li>

                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                      <div className="d-flex justify-content-between">
                        <span className="GothamBold fs-6">
                          +Serv({comission}%)
                        </span>
                        <span className="GothamBold fs-6">
                          {" "}
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission).serv
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </span>
                      </div>
                    </li>

                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-0 ">
                      <div className="d-flex justify-content-between">
                        <span className="GothamBold fs-5">Total</span>
                        <span className="GothamBold fs-5">
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission)
                                .total
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="d-block d-md-flex justify-content-center">
              <label
                className={
                  step == 0
                    ? "d-none"
                    : "btn btn-outline-dark fw-normal py-4 fs-6 d-flex justify-content-center align-items-center  me-2 mb-2 w-100 w-md-auto"
                }
                style={{
                  width: "160px",
                  lineHeight: 1,
                  padding: "10px 20px 10px",
                  borderRadius: "10px",
                }}
              >
                <i class="bi bi-chevron-left fs-6"></i>
                Atras
                <button
                  className="d-none"
                  onClick={(e) => {
                    let int = step - 1;
                    switch (int) {
                      case 0:
                        {
                          document.getElementById("nav-cantidad-tab").click();
                          document
                            .getElementById("nav-cantidad-tab-ofcanva")
                            .click();
                        }
                        break;
                      default:
                        break;
                    }
                    setStep(int);
                  }}
                ></button>
              </label>

              {label(step)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfComprarEntradas;
